import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Session} from '../../domain/session';
import {MatSidenav} from '@angular/material/sidenav';
import {CoreConfigurationService} from '../../core-configuration.service';

@Component({
    selector: 'app-admin-menu',
    templateUrl: './admin-menu.component.html',
    styleUrls: ['./admin-menu.component.css'],
    standalone: false
})
export class AdminMenuComponent implements OnInit {
  @Output() onLogout: EventEmitter<any> = new EventEmitter();

  @Input() isMobile: boolean;
  @Input() sidenav: MatSidenav;

  constructor(public session: Session, public coreConfiguration: CoreConfigurationService) {
  }

  ngOnInit() {
  }

  handleMenuClick() {
    if (this.isMobile) {
      this.sidenav.close();
    }
  }

  protected showShipmentAssign() {
    return !this.coreConfiguration.isMobile && this.session.showAssignShipmentToCarrier();
  }

  protected showOrderAssign() {
    return !this.coreConfiguration.isMobile && this.session.showAssignOrderToUser();
  }
}
